import useUiPreferences from "src/store/useUiPreferences";
import useSessionPreferences from "src/store/useSessionPreferences";
import {
  MdOutlineBarChart,
  MdOutlineLegendToggle,
  MdOutlineLineAxis,
} from "react-icons/md";
import { ReactElement, useMemo } from "react";
import { ICON_SIZES } from "src/constants/icons";

export default function useCharts() {
  const chartsUiPreferences = useUiPreferences((s) => s.charts);
  const setUiPreferences = useUiPreferences((s) => s.setUiPreferences);
  const { setChartPreferences, getChartPreferences } = useSessionPreferences();

  const updateChart = (updates: any) => {
    setUiPreferences({
      charts: updates,
    });
  };

  const currentChartsIcon: ReactElement = useMemo(() => {
    switch (chartsUiPreferences.type) {
      case "line": {
        return <MdOutlineLineAxis size={ICON_SIZES.SM} />;
      }
      case "mixed": {
        return <MdOutlineLegendToggle />;
      }
      default: {
        return <MdOutlineBarChart size={ICON_SIZES.SM} />;
      }
    }
  }, [chartsUiPreferences.type]);

  return {
    chartsUiPreferences,
    updateChart,
    getZoom: (chartId: string) => {
      return getChartPreferences(chartId).zoom;
    },
    updateZoom: (chartId: string, start: number, end: number) => {
      setChartPreferences(chartId, {
        zoom: {
          start,
          end,
        },
      });
    },
    currentChartsIcon,
  };
}
